import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  bookingUrlRow: {
    display: 'flex',
    alignItems: 'stretch',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
  bookingUrlField: {
    flex: '1 1 auto',
    minWidth: 0,
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1.25, 1.5),
    border: '1px solid #E0E0E0',
    borderRadius: 8,
    backgroundColor: '#FFFFFF',
  },
  bookingUrlText: {
    fontSize: '0.875rem',
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
  },
  bookingUrlCopyButton: {
    flexShrink: 0,
    width: 44,
    height: 44,
    border: '1px solid #E0E0E0',
    borderRadius: 8,
    color: '#172024',
    '&:hover': {
      backgroundColor: 'rgba(0, 35, 75, 0.04)',
    },
  },
  bookingUrlCopyIcon: {
    fontSize: 20,
  },
  shareActionsRow: {
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(4.5),
    [theme.breakpoints.down('xs')]: {
      gap: theme.spacing(3.5),
    },
  },
  shareAction: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1),
    flex: '0 0 auto',
  },
  shareActionButton: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 48,
    width: 48,
    height: 48,
    borderRadius: '50%',
    backgroundColor: '#CCDDFF',
    color: '#172024',
    padding: 0,
    minHeight: 48,
    textTransform: 'none',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#B8D0FF',
      boxShadow: 'none',
    },
  },
  shareActionIcon: {
    fontSize: 22,
    color: '#172024',
    lineHeight: 1,
    fontFamily: '"Material Symbols Rounded Variable"',
  },
  shareActionLabel: {
    fontSize: '0.75rem',
    lineHeight: 1.2,
    color: '#111111',
    textAlign: 'center',
  },
  socialMenu: {
    borderRadius: 8,
    border: '1px solid #E0E0E0',
    minWidth: 160,
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)',
  },
  socialMenuItem: {
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  socialMenuShareButton: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    width: '100%',
    padding: theme.spacing(1.25, 2),
    textDecoration: 'none',
    color: '#172024',
    fontSize: '0.875rem',
    fontWeight: 500,
    '&:hover': {
      backgroundColor: 'rgba(0, 35, 75, 0.04)',
    },
  },
  shareRow: {
    display: 'flex',
    minWidth: '52px',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '12px !important',
    borderRadius: '4px',
    textTransform: 'none',
    '& p': {
      marginLeft: '34px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '6px !important',
    },
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  linkButton: {
    borderRadius: '50%',
    background: 'rgba(0, 0, 0, 0.18)',
    height: '32px',
    width: '32px',
    padding: '5px',
  },
  title: {
    fontWeight: '500',
    color: 'rgba(0, 0, 0, 0.87)',
  },
  copyButton: {
    justifyContent: 'flex-start',
    padding: '4px 0 4px 10px',
  },
  messageButton: {
    '& span:first-of-type': {
      background: 'rgba(76, 175, 80, 1)',
      color: 'white',
      borderRadius: '50%',
      height: '30px',
      width: '30px',
      padding: '5px',
      '& svg, & .MuiSvgIcon-root': {
        width: '25px',
        height: '25px',
        fontSize: '25px',
      },
    },
  },
}))
